// extracted by css-extract-rspack-plugin
export default {"tab":"ProcedureCategoryTab__tab--Jybyx","inner":"ProcedureCategoryTab__inner--YLCPD","active":"ProcedureCategoryTab__active--MjH1D"};